import {NgControl} from '@angular/forms';
import {Directive, Input, inject} from '@angular/core';

// thx to https://netbasal.com/disabling-form-controls-when-working-with-reactive-forms-in-angular-549dd7b42110
@Directive({
    selector: '[disableControl]'
})
export class DisableControlDirective {

    private ngControl = inject(NgControl);

    @Input() set disableControl(condition: boolean) {
        const action = condition ? 'disable' : 'enable';
        setTimeout(() => {
            this.ngControl.control[action]();
        });
    }

}
